import { Entity } from '../../../data/types';

export interface IGroupedEntityListItem {
  sectionLabel: string;
  isSticky?: boolean;
  data: Entity;
}

export type GroupedEntityRelationship = 'groups' | 'teams';

/**
 * @description groups items by a parent item
 * @param parents - the list of possible group sections
 * @param entities - the list of items to group
 * @param relationship - the property on the item where the relationship is defined
 */
export const groupByParentEntity = (
  parents: Entity[],
  entities: Entity[],
  relationship: GroupedEntityRelationship
): IGroupedEntityListItem[] => {
  const items: IGroupedEntityListItem[] = [];
  for (const parent of parents) {
    const grouping: IGroupedEntityListItem[] = [];
    for (const entity of entities) {
      if (entity[relationship]?.includes(parent.id)) {
        grouping.push({
          isSticky: false,
          sectionLabel: parent.name,
          data: entity,
        });
      }
    }
    if (grouping.length > 0) {
      items.push({
        isSticky: true,
        sectionLabel: parent.name,
        data: parent,
      });
      items.push(...grouping);
    }
  }
  return items;
};
